import React from 'react'

import '../components/Styles/home.css'
import '../components/Styles/About.css'
import '../components/Styles/cont.css'
import {Helmet}from"react-helmet";
import c1 from './loc.png'
import c2 from './loc1.png'
import c3 from './loc2.png'
import c4 from './l2a.png'

import d1 from '../assets/images/d1.png'
import d2 from '../assets/images/d2.png'
import d3 from '../assets/images/d3.png'
import d4 from '../assets/images/d4.png'
import d5 from '../assets/images/d5.png'
import d6 from '../assets/images/d6.png'
import e1 from '../assets/images/e1.png'
import e2 from '../assets/images/e2.png'
import e3 from '../assets/images/e3.png'
import e4 from '../assets/images/e4.png'
import e5 from '../assets/images/e5.png'
import e6 from '../assets/images/e6.png'
import e7 from '../assets/images/e7.png'
import e8 from '../assets/images/e8.png'
import e9 from '../assets/images/e9.png'
import e10 from '../assets/images/e10.png'
const Cont = () => {
  const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);
  return (
    <div>
              <Helmet>
      
      <title>Xceed networking event - Xceed Office</title>
      <meta name="description" content="Get in touch with Xceed offices today to explore our modern co-working spaces in Houston. Our flexible workspaces are designed to inspire productivity and collaboration."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>


      <section className="networking-event">
      <div className="overlay">
        <div className="content">
          <span className="tag">NETWORKING EVENT</span>

          <h1>
            Xceed Office <span>Networking Open House</span>
          </h1>

          <p className="description">
            Join us at Xceed Office for an evening of professional networking,
            refreshments, office tours, and an event-only first month free
            membership promotion.
          </p>

          <div className="info-boxes">
            <div className="info-card">
              <h4 style={{display:'flex'}}><img src={c3} alt="" /> &nbsp;Location</h4>
              <p>3050 Post Oak Blvd</p>
              <small>Houston, TX</small>
            </div>

            <div className="info-card">
              <h4 style={{display:'flex'}}><img src={c2} alt="" />&nbsp; Date</h4>
              <p>July 31, 2026</p>
              <small>Save your spot</small>
            </div>

            <div className="info-card">
              <h4 style={{display:'flex'}}><img src={c1} alt="" />&nbsp; Time</h4>
              <p>6 PM – 8 PM</p>
              <small>Free with RSVP</small>
            </div>
          </div>
          <a
  href="https://xceed.nexudus.site/Xceed/events/view/1415748415/xceed-office-networking-open-house"
  target="_blank"
  rel="noopener noreferrer"
>
          <button className="rsvp-btn">
            RSVP for Free <span>→</span>
          </button>
</a>
          <p className="footer-text">
            Meet local business owners, professionals, consultants,
            entrepreneurs, and community members while experiencing Xceed
            Office in person.
          </p>
        </div>
      </div>
    </section>
    <section className="about-event">
        <div className='abcont'>
  <div className="about-container">
    <div className="about-content">
      <span className="about-tag">ABOUT THE EVENT</span>

      <h2>
        Connect, Network, and <br />
        <span>Experience Xceed Office</span>
      </h2>

      <p>
        You are invited to the Xceed Office Networking Open House at
        3050 Post Oak Blvd.
      </p>

      <p>
        This event is designed to bring local professionals, business
        owners, entrepreneurs, consultants, advisors, and community
        members together in a polished professional setting.
      </p>

      <p>
        Guests will have the opportunity to network with others, enjoy
        pizza, sodas, and ice cream, tour the Xceed Office space, and
        learn more about our private offices, executive suites,
        meeting rooms, and business membership options.
      </p>

      <p>
        Whether you are looking for a professional workspace, a place
        to meet clients, a business address, or simply want to connect
        with other professionals in Houston, we would love to have you
        join us.
      </p>
    </div>

    <div className="about-image">
      <img src={c4} alt="Conference Room" />
    </div>
  </div>
  </div>
</section>
<section style={{background:'#14141480'}} className="event-experience">
  <div className="experience-container">
    <div className="experience-header">
      <span className="experience-tag">EVENT EXPERIENCE</span>
      <h2>
        What to Expect at the <span>Event</span>
      </h2>
    </div>

    <div className="experience-grid">
      <div className="experience-card">
        <div className="icon"><img src={d1} alt="" /></div>
        <h3>Professional Networking</h3>
        <p>
          Meet and connect with local professionals, entrepreneurs,
          business owners, consultants, and service providers in the
          Houston area.
        </p>
      </div>

      <div className="experience-card">
        <div className="icon"><img src={d2} alt="" /></div>
        <h3>Refreshments</h3>
        <p>
          Enjoy pizza, sodas, and ice cream while networking and
          exploring the space.
        </p>
      </div>

      <div className="experience-card">
        <div className="icon"><img src={d3} alt="" /></div>
        <h3>Office Tours</h3>
        <p>
          Take a guided tour of Xceed Office and see our private
          offices, executive suites, meeting rooms, reception area,
          and professional amenities.
        </p>
      </div>

      <div className="experience-card">
        <div className="icon"><img src={d4} alt="" /></div>
        <h3>Business Connections</h3>
        <p>
          Introduce yourself, exchange contacts, and build
          relationships with professionals who may become clients,
          partners, or referral sources.
        </p>
      </div>

      <div className="experience-card">
        <div className="icon"><img src={d5} alt="" /></div>
        <h3>Event-Only Promotion</h3>
        <p>
          Guests who attend the event may qualify for a first month
          free promotion on eligible Xceed Office memberships.
        </p>
      </div>

      <div className="experience-card">
        <div className="icon"><img src={d6} alt="" /></div>
        <h3>Photos and Videos</h3>
        <p>
          We will be capturing photos and videos during the event for
          Xceed Office marketing, social media, and promotional
          content.
        </p>
      </div>
    </div>
  </div>
</section>
<section className="audience-section">
  <div className="audience-container">
    <div className="audience-content">
      <span className="audience-tag">AUDIENCE</span>

      <h2>
        Who Should <span>Attend?</span>
      </h2>

      <p>
        This event is ideal for professionals and business owners who
        want to expand their network, explore a professional workspace,
        or learn more about Xceed Office.
      </p>
    </div>

    <div className="audience-grid">
      <div className="audience-card">
        <span className="icon"><img src={e1} alt="" /></span>
        <p>Local business owners</p>
      </div>

      <div className="audience-card">
        <span className="icon"><img src={e2} alt="" /></span>
        <p>Entrepreneurs</p>
      </div>

      <div className="audience-card">
        <span className="icon"><img src={e3} alt="" /></span>
        <p>Lawyers and legal professionals</p>
      </div>

      <div className="audience-card">
        <span className="icon"><img src={e4} alt="" /></span>
        <p>CPAs and accounting professionals</p>
      </div>

      <div className="audience-card">
        <span className="icon"><img src={e5} alt="" /></span>
        <p>Financial advisors and consultants</p>
      </div>

      <div className="audience-card">
        <span className="icon"><img src={e6} alt="" /></span>
        <p>Real estate professionals</p>
      </div>

      <div className="audience-card">
        <span className="icon"><img src={e7} alt="" /></span>
        <p>Independent consultants</p>
      </div>

      <div className="audience-card">
        <span className="icon"><img src={e8} alt="" /></span>
        <p>Remote professionals</p>
      </div>

      <div className="audience-card">
        <span className="icon"><img src={e9} alt="" /></span>
        <p>Startups and growing businesses</p>
      </div>

      <div className="audience-card">
        <span className="icon"><img src={e10} alt="" /></span>
        <p>
          Anyone interested in office space, meeting rooms, or
          professional networking
        </p>
      </div>
    </div>
  </div>
</section>
<section style={{background:'#14141480'}} className="office-section">
  <div className="office-container">
    <div className="office-content">
      <span className="office-tag">ABOUT XCEED OFFICE</span>

      <h2>
        A Professional Workspace
        <br />
        Designed for <span>Serious Professionals</span>
      </h2>

      <p>
        Xceed Office provides a professional and polished workspace
        environment for businesses, entrepreneurs, and client-facing
        professionals in Houston.
      </p>

      <p>
        Our office solutions are designed for professionals who want
        more than a basic workspace. Whether you need a private office,
        executive suite, meeting room, or professional business
        presence, Xceed Office gives you a place to work, meet, and
        grow with confidence.
      </p>
    </div>

    <div className="office-features">
      <h3>Feature Highlights</h3>

      <div className="feature-grid">
        <div className="feature-card">
          <span className="feature-icon">✓</span>
          <p>Private offices</p>
        </div>

        <div className="feature-card">
          <span className="feature-icon">✓</span>
          <p>Executive suites</p>
        </div>

        <div className="feature-card">
          <span className="feature-icon">✓</span>
          <p>Professional meeting rooms</p>
        </div>

        <div className="feature-card">
          <span className="feature-icon">✓</span>
          <p>Reception area</p>
        </div>

        <div className="feature-card">
          <span className="feature-icon">✓</span>
          <p>Business-friendly environment</p>
        </div>

        <div className="feature-card">
          <span className="feature-icon">✓</span>
          <p>Convenient Post Oak location</p>
        </div>

        <div className="feature-card">
          <span className="feature-icon">✓</span>
          <p>Professional setting for client meetings</p>
        </div>

        <div className="feature-card">
          <span className="feature-icon">✓</span>
          <p>Flexible membership options</p>
        </div>

        <div className="feature-card">
          <span className="feature-icon">✓</span>
          <p>Networking and community opportunities</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section className="promotion-section">
  <div className="promotion-container">
    <div className="promotion-content">
      <span className="promotion-tag">✨ EVENT-ONLY PROMOTION</span>

      <h2>
        First Month <span>Free</span>
      </h2>

      <p>
        As a thank-you for attending the Xceed Office Networking Open
        House, guests may qualify for a special event-only promotion.
      </p>

      <p>
        Attend the event and receive access to our first month free
        offer on eligible Xceed Office memberships.
      </p>
      <a
  href="https://xceed.nexudus.site/Xceed/events/view/1415748415/xceed-office-networking-open-house"
  target="_blank"
  rel="noopener noreferrer"
></a>
      <button className="promotion-btn">
        RSVP for Free <span>→</span>
      </button>
      <a/>
    </div>

    <div className="promotion-details">
      <h3>Promotion Details</h3>

      <ul className="promotion-list">
        <li>First month free on eligible memberships</li>
        <li>Available to event attendees only</li>
        <li>Applies to new members only</li>
        <li>Subject to availability</li>
        <li>May require a signed membership agreement</li>
        <li>Must be redeemed within 7–14 days of the event</li>
      </ul>

      <div className="promotion-note">
        <h4>IMPORTANT NOTE</h4>
        <p>
          Promotion terms may vary by membership type and office
          availability.
        </p>
        <p>
          Final approval is subject to Xceed Office membership
          requirements.
        </p>
      </div>
    </div>
  </div>
</section>
<section style={{background:'#14141480'}} className="location-section">
  <div className="location-container">
    <div className="location-content">
      <span className="location-tag">LOCATION</span>

      <h2>
        Join Us at <span>Xceed Office</span>
      </h2>

      <p>
        The event will be hosted at Xceed Office, located at
        3050 Post Oak Blvd in Houston.
      </p>

      <div className="address-card">
        <div className="address-icon"><img src={c3} alt="" /></div>

        <div className="address-info">
          <span>ADDRESS</span>
          <h4>Xceed Office</h4>
          <p>3050 Post Oak Blvd</p>
          <small>Houston, TX</small>
        </div>
      </div>

      <button className="direction-btn">
        Get Directions <span>→</span>
      </button>
    </div>

    <div className="location-map">
    <iframe
            title="3050 Post Oak Blvd"
            className="msgMapCard__map"
            src="https://www.google.com/maps?q=3050+Post+Oak+Blvd+Houston+TX+77056&output=embed"
            loading="lazy"
          />
    </div>
  </div>
</section>
<section className="rsvp-section">
  <div className="rsvp-container">
    <div className="rsvp-header">
      <h2>
        Reserve Your <span>Spot</span>
      </h2>

      <p>
        RSVP today to join us for the Xceed Office Networking Open
        House. Space may be limited, so we recommend reserving your
        spot in advance.
      </p>
    </div>

    <form
  className="rsvp-form"
  action="https://formsubmit.co/info@xceedoffice.com"
  method="POST"
>
  {/* Hidden Fields */}
  <input
    type="hidden"
    name="_subject"
    value="New RSVP - Xceed Office Networking Open House"
  />

  <input
    type="hidden"
    name="_captcha"
    value="false"
  />

  <input
    type="hidden"
    name="_template"
    value="table"
  />

  <input
    type="hidden"
    name="_next"
    value="https://xceedoffice.com/xceed-networking-event?success=true"
  />

  <div className="form-grid">
    <div className="form-group">
      <label>First Name</label>
      <input
        type="text"
        name="First Name"
        placeholder="Enter your first name"
        required
      />
    </div>

    <div className="form-group">
      <label>Last Name</label>
      <input
        type="text"
        name="Last Name"
        placeholder="Enter your last name"
        required
      />
    </div>

    <div className="form-group">
      <label>Email Address</label>
      <input
        type="email"
        name="Email"
        placeholder="Enter your email"
        required
      />
    </div>

    <div className="form-group">
      <label>Phone Number</label>
      <input
        type="tel"
        name="Phone"
        placeholder="Enter your phone number"
      />
    </div>

    <div className="form-group">
      <label>Company Name</label>
      <input
        type="text"
        name="Company"
        placeholder="Company name"
      />
    </div>

    <div className="form-group">
      <label>Profession / Industry</label>
      <input
        type="text"
        name="Profession"
        placeholder="Profession / Industry"
      />
    </div>
  </div>

  <div className="radio-section">
    <label className="section-title">
      What are you most interested in?
    </label>

    <div className="option-grid">
      <label>
        <input
          type="radio"
          name="Interest"
          value="Private Office"
          required
        />
        Private Office
      </label>

      <label>
        <input
          type="radio"
          name="Interest"
          value="Executive Suite"
        />
        Executive Suite
      </label>

      <label>
        <input
          type="radio"
          name="Interest"
          value="Virtual Office"
        />
        Virtual Office
      </label>

      <label>
        <input
          type="radio"
          name="Interest"
          value="Meeting Room"
        />
        Meeting Room
      </label>

      <label>
        <input
          type="radio"
          name="Interest"
          value="Networking Only"
        />
        Networking Only
      </label>

      <label>
        <input
          type="radio"
          name="Interest"
          value="Not Sure Yet"
        />
        Not Sure Yet
      </label>
    </div>
  </div>

  <div className="radio-section">
    <label className="section-title">
      When are you looking for office space or business services?
    </label>

    <div className="option-grid">
      <label>
        <input
          type="radio"
          name="Timeline"
          value="Immediately"
          required
        />
        Immediately
      </label>

      <label>
        <input
          type="radio"
          name="Timeline"
          value="Within 30 Days"
        />
        Within 30 Days
      </label>

      <label>
        <input
          type="radio"
          name="Timeline"
          value="1–3 Months"
        />
        1–3 Months
      </label>

      <label>
        <input
          type="radio"
          name="Timeline"
          value="Just Exploring"
        />
        Just Exploring
      </label>

      <label>
        <input
          type="radio"
          name="Timeline"
          value="Not Looking Right Now"
        />
        Not Looking Right Now
      </label>
    </div>
  </div>

  <div className="radio-section">
    <label className="section-title">
      Would you like someone from Xceed Office to contact you before the event?
    </label>

    <div className="option-grid two">
      <label>
        <input
          type="radio"
          name="Contact Before Event"
          value="Yes"
          required
        />
        Yes
      </label>

      <label>
        <input
          type="radio"
          name="Contact Before Event"
          value="No"
        />
        No
      </label>
    </div>
  </div>

  <button type="submit" className="submit-btn">
    Submit RSVP →
  </button>
</form>
  </div>
</section>
<section style={{background:'#14141480'}} className="notice-section">
  <div className="notice-container">
    <div className="notice-card">
      <div className="notice-icon">
        <img src={d6} alt="" />
      </div>

      <div className="notice-content">
        <span className="notice-tag">
          PHOTO AND VIDEO NOTICE
        </span>

        <h3>Photo and Video Notice</h3>

        <p>
          Please note that photos and videos may be taken during the event
          for Xceed Office marketing, social media, and promotional
          purposes. By attending the event, guests acknowledge that they
          may appear in event-related photos or videos.
        </p>
      </div>
    </div>
  </div>
</section>
<section className="cta-section">
  <div className="cta-container">
    <div className="cta-overlay">
      <h2>
        Ready to <span>Connect?</span>
      </h2>

      <p>
        Join us for an evening of networking, refreshments, office tours,
        and professional connections at Xceed Office.
      </p>

      <p>
        Whether you are actively looking for office space or simply want
        to meet other professionals in Houston, this is a great opportunity
        to experience Xceed Office in person.
      </p>

      <a
  href="https://xceed.nexudus.site/Xceed/events/view/1415748415/xceed-office-networking-open-house"
  target="_blank"
  rel="noopener noreferrer"
>
  <button className="cta-btn">
    RSVP for Free <span>→</span>
  </button>
</a>
    </div>
  </div>
</section>
    </div>
  )
}

export default Cont